// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1-7-p","fileDisabled":"File_fileDisabled__2COTX"};